<!--
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-07-10 14:48:24
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\Footer.vue
-->
<template>
  <div class="footer">
    <div class="footer-content">
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备05042718号-1</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020540"
        target="_blank">京公网安备11010802020540号</a>
    </div>

    <div class="copyright">Copyright &copy; 2023-2025 北京致远互联软件股份有限公司. All Rights Reserved</div>
  </div>
</template>
<script>
export default {
  name: "footer-cmp"
};
</script>
<style scoped lang="scss">
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0px 2px 24px 0px rgba(0,0,0,0.10); 
  font-size: 12px;
  padding: 0 10px;
  text-align: center;
  .footer-content {
    margin-bottom: 2px;
    a{
      color: #333333;
    }
    a+a{
      margin-left: 10px;
    }
  }
}

.copyright {
  color: #888888;
  line-height: 1.2;
}
::v-deep .feedback{
  bottom: 10%;
}
@media screen and (max-width: 600px) {
  .footer_down {
    font-size: 12px;
    height: 70px;
  }
}
</style>